<template>
	<modal :modal-id="modalId" :title="'View Voucher'" :preloader="preloader" @close-modal="closeModal" afterError
		:modal-scroll="false" :is-need-button-footer="false">
		<template slot="body">
			<app-overlay-loader v-if="preloader" />
			<form class="mb-0" :class="{ 'loading-opacity': preloader }" ref="form">

				<!-- Generated Voucher Code -->
				<div v-if="value?.voucher_code" class="form-group row align-items-center">
					<label class="col-sm-3 mb-0" style="opacity: 0.75;">
						{{ $t("form_voucher_code") }}
					</label>
					<p class="col-sm-9 text-lg my-auto" v-html="value?.voucher_code"></p>
				</div>
				<!-- Generated Voucher Code -->

				<!-- Voucher Category -->
				<div v-if="value?.voucher_category_description" class="form-group row align-items-center">
					<label class="col-sm-3 mb-0" style="opacity: 0.75;">
						{{ $t("form_voucher_category") }}
					</label>
					<p class="col-sm-9 text-lg my-auto" v-html="value?.voucher_category_description"></p>
				</div>
				<!-- Voucher Category -->

				<!-- Voucher Type -->
				<div v-if="value?.voucher_type" class="form-group row align-items-center">
					<label class="col-sm-3 mb-0" style="opacity: 0.75;">
						{{ $t("form_voucher_specify") }}
					</label>
					<p class="col-sm-9 text-lg my-auto" v-html="value?.voucher_type"></p>
				</div>
				<!-- Voucher Type -->

				<!--To Student -->
				<div v-if="value?.to_lead_name" class="form-group row align-items-center">
					<label class="col-sm-3 mb-0" style="opacity: 0.75;">
						{{ $t("form_voucher_lead_to") }}
					</label>
					<p class="col-sm-9 text-lg my-auto" v-html="value?.to_lead_name"></p>
				</div>
				<!-- To Student -->

				<!--By Student -->
				<div v-if="value?.recommended_by" class="form-group row align-items-center">
					<label class="col-sm-3 mb-0" style="opacity: 0.75;">
						{{ $t("form_voucher_lead_by") }}
					</label>
					<p class="col-sm-9 text-lg my-auto" v-html="value?.recommended_by"></p>
				</div>
				<!-- By Student -->

				<!-- Valid From -->
				<div v-if="value?.academic_calendar_name" class="form-group row align-items-center">
					<!-- Academic Calendar -->
					<label class="col-sm-3 mb-0" style="opacity: 0.75;">
						{{ $t("table_voucher_valid_from") }}
					</label>
					<p class="col-sm-6 text-lg my-auto" v-html="value?.academic_calendar_name"></p>
					<!-- Academic Calendar -->

					<!-- School Term -->
					<p class="col-sm-3 text-lg my-auto" v-html="'Term ' + value?.school_term"></p>
					<!-- School Term -->
				</div>
				<!-- Valid From -->

				<!-- Due Date -->
				<div v-if="value?.due_date" class="form-group row align-items-center">
					<label class="col-sm-3 mb-0" style="opacity: 0.75;">
						{{ $t("form_voucher_due_date") }}
					</label>
					<p class="col-sm-9 text-lg my-auto" v-html="value?.due_date"></p>
				</div>
				<!-- Due Date -->

				<!-- Nominal Deduction -->
				<div v-if="value?.deduction" class="form-group row align-items-center">
					<label class="col-sm-3 mb-0" style="opacity: 0.75;">
						{{ $t("form_voucher_nominal") }}
					</label>
					<p class="col-sm-9 text-lg my-auto" v-html="formattedIDR(value?.deduction)"></p>
				</div>
				<!-- Nominal Deduction -->

				<!-- Reason -->
				<div v-if="value?.reason" class="form-group row align-items-center">
					<label class="col-sm-3 mb-0" style="opacity: 0.75;">
						{{ $t("form_voucher_reason") }}
					</label>
					<p class="col-sm-9 text-lg my-auto" v-html="value?.reason"></p>
				</div>
				<!-- Reason -->

				<!-- Reason Rejection -->
				<div v-if="value?.reason_rejection" class="form-group row align-items-center">
					<label class="col-sm-3 mb-0" style="opacity: 0.75;">
						{{ $t("form_voucher_reason") }} Rejection
					</label>
					<p class="col-sm-9 text-lg my-auto" v-html="value?.reason_rejection"></p>
				</div>
				<!-- Reason Rejection -->

			</form>
		</template>

		<template slot="footer">
			<button type="button" class="btn btn-secondary mr-2" data-dismiss="modal" @click="closeModal">
				{{ $t('close') }}
			</button>
		</template>
	</modal>
</template>

<script>
import { ModalMixin } from "../../../../Mixins/ModalMixin.js";
export default {
	name: "ModalFormView",
	mixins: [ModalMixin],
	props: {
		modalId: {
			type: String,
			required: true,
		},
		value: {
			type: Object,
			default: () => {
				return {
					lead_to: {
						id: undefined,
						name: '',
					},
					voucher_category: {
						id: undefined,
						code: '',
					},
					voucher_category_description: {
						id: undefined,
						code: '',
					},
					academic_calendar: {
						id: undefined,
						academic_calender_name: '',
						date_start: '',
						date_end: '',
					},
					school_term: 1,
					due_date: '',
					reason: '',
					reason_rejection: '',
				};
			},
		},
	},
	data() {
		return {
			preloader: false,
		};
	},
	methods: {
		getWeekOfYear(date = new Date()) {
			const startOfYear = new Date(date.getFullYear(), 0, 1);
			const pastDays = (date - startOfYear) / 86400000; // ms in a day
			return Math.ceil((pastDays + startOfYear.getDay() + 1) / 7);
		},
		getTermByDate(date = new Date()) {
			if (typeof date === 'string') date = new Date(date);
			const week = this.getWeekOfYear(date);
			if (week <= 14) {
				return 3;
			}
			else if (week <= 26) {
				return 4;
			}
			else if (week <= 40) {
				return 1;
			}
			else {
				return 2;
			}
		},
		formattedIDR(value) {
			// Format the value as IDR
			return new Intl.NumberFormat("id-ID", {
				style: "currency",
				currency: "IDR",
				minimumFractionDigits: 0,
			}).format(value);
		},
	},
}
</script>
